/**
 * SA-1316 (spec §2, §3, §8): a task tour, one walkthrough section played on the real
 * screen. Built at `npm run docs:corpus` into `content/help/taskTours.json`; the engine
 * plays it. Pure types.
 *
 * - `go` rings a nav link (`nav`, a route) or an anchor to pick from (`anchor`), and
 *   completes when the location matches one of `routes`.
 * - `do` rings `anchor` and completes on a click or a change inside it; `name` is the
 *   on-screen word the person presses.
 * - `read` shows `text` (and `expect`) with no ring.
 */
export type TaskTourMode = 'go' | 'do' | 'read'

export interface TaskTourStep {
  mode: TaskTourMode
  anchor?: string
  nav?: string
  routes?: string[]
  /** The page a go step reaches, for the "open it from the menu" line. */
  title?: string
  text: string
  expect?: string
  name?: string
}

/** A route the tour visits, with what the app map says it needs. */
export interface TaskTourRoute { path: string; features: string[]; permissions: string[] }

export interface TaskTour {
  id: string
  title: string
  kind: 'task'
  routes: TaskTourRoute[]
  steps: TaskTourStep[]
}

/** The record noun's place in a go step's words; the engine puts the deployment's noun there. */
export const RECORDS_TOKEN = '{records}'
